module.exports = __webpack_public_path__ + "media/images/img/logo-890cd42b36965a0d5cedcfd2427da86a.svg";